import React, { useContext, useState } from 'react';

import { getTranslation, keys } from '../../../../../../Resources/Translations';
import { postFor } from '../../../../../ReactComponents/API';
import { UserContext } from '../../../../../ReactComponents/Contexts/UserContext';
import { RegexProvider } from '../../../../../ReactComponents/RegexProvider';
import { ProductAvailabilityNotificationRequest } from '../../Models/ProductAvailabilityNotificationRequest.csharp';
import { ProductAvailabilityNotificationResponse } from '../../Models/ProductAvailabilityNotificationResponse.csharp';
import { ProductAvailabilityNotificationResponseStatus } from '../../Models/ProductAvailabilityNotificationResponseStatus.csharp';
import { ProductAvailabilityNotificationsInputModal } from '../ProductAvailabilityNotificationsInputModal';
import { ProductAvailabilityNotificationProps } from './ProductAvailabilityNotificationProps.csharp';
import { ProductAvailabilityNotificationViewType } from './ProductAvailabilityNotificationViewType.csharp';
import { ProductAvailabilityNotificationCardView } from './Views/ProductAvailabilityNotificationCardView';
import { ProductAvailabilityNotificationPageView } from './Views/ProductAvailabilityNotificationPageView';
import { ProductAvailabilityNotificationStatus } from './Views/ProductAvailabilityNotificationStatus';
import { ProductAvailabilityNotificationViewProps } from './Views/ProductAvailabilityNotificationViewProps';

export const ProductAvailabilityNotification = (props: ProductAvailabilityNotificationProps) => {
    const [status, setStatus] = useState<ProductAvailabilityNotificationStatus>(ProductAvailabilityNotificationStatus.Input);
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isRequestActive, setIsRequestActive] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isInputModalVisible, setIsInputModalVisible] = useState(false);
    const userContext = useContext(UserContext);

    const handleOnClick = () => {
        if (userContext.isLogged) {
            handleSubmit();
        } else {
            setIsInputModalVisible(true);
        }
    };

    const handleSubmit = () => {
        setErrorMessage('');

        if (!userContext.isLogged && !RegexProvider.email.test(email)) {
            return setErrorMessage(getTranslation(keys['product.availabilityNotification.incorrectEmail']));
        }

        const request: ProductAvailabilityNotificationRequest = {
            isLoggedIn: userContext.isLogged,
            customerEmail: email,
            variantSku: props.variantSku
        };

        setIsRequestActive(true);

        postFor<ProductAvailabilityNotificationResponse>(props.url, request)
            .then((result) => {
                if (result.status === ProductAvailabilityNotificationResponseStatus.Ok) {
                    setStatus(ProductAvailabilityNotificationStatus.Success);
                }
            })
            .catch((error) => {
                try {
                    const result = error.json() as ProductAvailabilityNotificationResponse;

                    if (result.status === ProductAvailabilityNotificationResponseStatus.LimitExceeded) {
                        return setStatus(ProductAvailabilityNotificationStatus.LimitExceeded);
                    }
                } catch {
                    setErrorMessage(getTranslation(keys['product.availabilityNotification.unexpectedError']));
                }
            })
            .finally(() => {
                setIsRequestActive(false);
            });
    };

    const viewProps: ProductAvailabilityNotificationViewProps = {
        status,
        errorMessage,
        handleOnClick,
        isButtonDisabled,
        isInputModalVisible,
        isRequestActive
    };

    return (
        <div>
            {props.viewType === ProductAvailabilityNotificationViewType.ProductCard && <ProductAvailabilityNotificationCardView {...viewProps} />}
            {props.viewType === ProductAvailabilityNotificationViewType.ProductPage && <ProductAvailabilityNotificationPageView {...viewProps} />}

            <ProductAvailabilityNotificationsInputModal
                checkEmailUrl={props.checkEmailUrl}
                setEmail={setEmail}
                setErrorMessage={setErrorMessage}
                setIsButtonDisabled={setIsButtonDisabled}
                errorMessage={errorMessage}
                handleSubmit={handleSubmit}
                isRequestActive={isRequestActive}
                isButtonDisabled={isButtonDisabled}
                isVisible={status === ProductAvailabilityNotificationStatus.Input && isInputModalVisible}
                setIsVisible={setIsInputModalVisible}
            />
        </div>
    );
};
